import { admGraphqlRequest, aomGraphqlRequest } from 'core/utils/backend-service';
import { DeviceTypeDetails, DeviceTypeDetailsAPI } from 'modules/devices/domain/api/device-type.api';
import { mapDeviceTypeDetailsFromApiToModel } from 'modules/devices/domain/mappers';
import { FetchDeviceTypesStrategy } from '../device-types.type';
import { deviceTypesAdmQuery, deviceTypesAomQuery } from './device-types.queries';

const mapResponse = (response: {
    data: { deviceTypes: DeviceTypeDetailsAPI[] };
}): {
    result: { deviceTypes: DeviceTypeDetails[] };
} => ({
    result: {
        deviceTypes: response.data.deviceTypes.map((d) => mapDeviceTypeDetailsFromApiToModel(d)),
    },
});

export const fetchDeviceTypesFromADM: FetchDeviceTypesStrategy = () =>
    admGraphqlRequest(deviceTypesAdmQuery()).then((response) =>
        mapResponse(response as unknown as { data: { deviceTypes: DeviceTypeDetailsAPI[] } })
    );

export const fetchDeviceTypesFromAOM: FetchDeviceTypesStrategy = () =>
    aomGraphqlRequest(deviceTypesAomQuery()).then((response) =>
        mapResponse(response as unknown as { data: { deviceTypes: DeviceTypeDetailsAPI[] } })
    );
